import * as React from 'react';

import GirlsIcon from '@/components/elements/Icon/Girls';
import GradeIcon from '@/components/elements/Icon/Grade';
import TimeFrameIcon from '@/components/elements/Icon/TimeFrame';
import { TimeFrame } from '@/lib/apollo/types/gen/graphql';

import { Icons } from './style';

interface RaceInfoIconProps {
  gradeName: string;
  timeFrame: TimeFrame;
  isGirls: boolean;
}

const RaceInfoIcon: React.FC<RaceInfoIconProps> = React.memo(
  ({ gradeName, timeFrame, isGirls }) => (
    <Icons>
      <GradeIcon gradeName={gradeName} />
      <TimeFrameIcon timeFrame={timeFrame} />
      <GirlsIcon isGirls={isGirls} />
    </Icons>
  ),
);

export default RaceInfoIcon;
